export default defineAppConfig({
    base: {
      type: 'web',      
      apiBaseUrl: 'https://staging-api.tensormap.ai/'
    },
    tairo: {
      title: 'TensorMap',
      description: '',
      error: {
        logo: {
          component: 'TairoLogo',
          props: { class: 'text-primary-500 mx-auto h-40 p-6' },
        },
      },    
      panels: [],      
      iconnav: {
        circularMenu: {
          enabled: false,
          tools: [],
        },
        toolbar: {
          tools: [
            {
              component: 'BaseNavigationDropdown',       
              // props: { name: 'User'}     
            },
          ]
        },
        navigation: {
          logo: {
            component: 'TensorLogoText',          
            props: { class: 'mx-auto' },
          },
          items: [         
            {
              name: 'Surveys',
              // icon: { name: 'ph:gear-six-duotone', class: 'w-6 h-6' },
              to: '/surveys',
            },    
            {
              name: 'Products',
              // icon: { name: 'ph:gear-six-duotone', class: 'w-6 h-6' },
              to: '/products',
            },    
            // {
            //   name: 'Transactions',
            //   // icon: { name: 'ph:gear-six-duotone', class: 'w-6 h-6' },
            //   to: '/transactions',
            // },          
          ],
        },
      },
    },
  })
  